import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'interest',
      { selected: _ctx.isSelect },
      { remove: _ctx.isRemove },
      { disable: _ctx.disable }
    ])
  }, _toDisplayString(_ctx.label), 3))
}